import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  ApplicationForm,
  ChallengeDetails,
  ChallengeHeader,
  PoweredBySaral,
} from '../components/challenge-application-form';
import { Heading, Text } from '../components/styledComponents';
import { getChallengeApplicationPage } from '../services/inbound.service';
import { ChallengeApplicationPage } from '../types/challenges';
import useIsMobile from '../hooks/useIsMobile';
import LoaderSvg from '../assets/images/loader.svg';
import ForbiddenVectorImage from '../assets/images/forbidden-vector-image.svg';
import ApplicationGrid from '../assets/images/challenge-application-grid.svg';
import forbiddenStyles from '../styles/forbidden.module.css';
import styles from '../styles/challengeApplication.module.css';

export default function ChallengeApplication() {
  const { challengeId = '' } = useParams();
  const isMobile = useIsMobile();
  const [applicationPage, setApplicationPage] = useState<ChallengeApplicationPage | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchApplicationPage = async () => {
      setIsLoading(true);
      try {
        const response = await getChallengeApplicationPage(challengeId);
        setApplicationPage(response.status === true ? response.data : null);
      } catch (err) {
        setApplicationPage(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchApplicationPage();
  }, [challengeId]);

  useEffect(() => {
    if (applicationPage) document.title = `${applicationPage.challenge.name} | ${applicationPage.brandName}`;
  }, [applicationPage]);

  if (isLoading) {
    return (
      <div className="loader-div">
        <img src={LoaderSvg} alt="loader" width={100} />
      </div>
    );
  }

  if (!applicationPage) {
    return (
      <div className={forbiddenStyles.container}>
        <div className={forbiddenStyles.leftContainer}>
          <img src={ForbiddenVectorImage} alt="" />
        </div>
        <div className={forbiddenStyles.rightContainer}>
          <Heading>Oops!</Heading>
          <Text>This challenge is no longer accepting applications.</Text>
        </div>
      </div>
    );
  }

  const showEmailTooltip = applicationPage.challenge.reward.type === 'flat_fee';

  return (
    <div className={styles.page}>
      <ChallengeHeader brandName={applicationPage.brandName} />
      {isMobile ? (
        <main className={styles.mobileBody}>
          <section className={styles.mobileHero}>
            <ChallengeDetails applicationPage={applicationPage} />
          </section>
          <div className={styles.mobileDivider} />
          <ApplicationForm
            challengeId={challengeId}
            showEmailTooltip={showEmailTooltip}
            className={styles.mobileForm}
          />
          <PoweredBySaral className={styles.mobilePoweredBy} />
        </main>
      ) : (
        <main className={styles.body}>
          <img src={ApplicationGrid} alt="" className={styles.grid} />
          <div className={styles.left}>
            <ChallengeDetails applicationPage={applicationPage} />
            <PoweredBySaral />
          </div>
          <div className={styles.applyCard}>
            <ApplicationForm challengeId={challengeId} showEmailTooltip={showEmailTooltip} />
          </div>
        </main>
      )}
    </div>
  );
}
